import { Modal } from "react-bootstrap"
import classes from "./modal.module.css"
import AlertCircle from '@/assets/svg/icons/alert-circle.svg';
import AlertTriangle from '@/assets/svg/icons/alert-triangle.svg';
import CheckCircle from '@/assets/svg/icons/check-circle.svg';
import FeaturedIcon from "../icons/featured_icon";
import { Fragment } from "react";

const types = {
    success: {icon: CheckCircle},
    error: {icon: AlertCircle},
    warning: {icon: AlertTriangle}
}

export default function CustomModal({show, close, type, title, children, warning_text, buttons}) {

    return <Modal show={show} onHide={close} className={`${classes.modal}`} dialogClassName={`${classes["modal-dialog"]}`} contentClassName={`${classes["modal-content"]}`}>
    <div className={`${classes["modal-main-content"]} ${type ? classes[type] : ''}`}>
        <div className={`${classes["modal-main-content-inner"]}`}>
            {type && types[type] && <FeaturedIcon size="lg" color={type} icon={types[type].icon} outline />}
            <div className={`${classes["text-container"]}`}>
                <h2 className="margin-0 text-xl-semibold color-gray-900">{title}</h2>
                <div className={`${classes["scroll-content"]}`} data-modal-scroll-content>
                    {children}
                    {warning_text && <div className={`${classes["warning-text"]} ${type ? classes[type] : ''} text-sm-regular color-gray-800`}>{warning_text}</div>}
                </div>
            </div>
        </div>
        <div className={`${classes["button-container"]}`}>
            {buttons && buttons.map((b, index) => <Fragment key={`modal-btn-${index}`}>{b}</Fragment>)}
        </div>
    </div>
  </Modal>
}